export default __webpack_public_path__ + "sillchannel.svg";